<p-toast [styleClass]="'toast'" key="notifications" position="top-right" [baseZIndex]="5000">
  <ng-template let-notification pTemplate="notification">
    <app-notification [actions]="notification.data?.actions" [message]="notification.detail"
      [severity]="notification.severity" [summary]="notification.summary"
      [cartNotification]="notification.data?.cartNotification" [quantity]="notification.data?.quantity"
      [product]="notification.data?.product" [productVariant]="notification.data?.productVariant"
      [searchResult]="notification.data?.searchResult" [productName]="
        notification.data?.product?.name || 
        notification.data?.productVariant?.name || 
        notification.data?.selectedAsset?.name ||
        notification.data?.searchResult?.productVariantName
        " [featuredAsset]="
        notification.data?.product?.featuredAsset || 
        notification.data?.productVariant?.featuredAsset || 
        notification.data?.selectedAsset || 
        notification.data?.searchResult?.productAsset
        
        "></app-notification>
  </ng-template>

</p-toast>


<app-navigation></app-navigation>

<div class="router-wrapper">
  <router-outlet></router-outlet>
</div>


<app-footer></app-footer>
<!-- TEST -->